export default {
  path: 'wrapped-components',
  name: 'Wrapped components',
  childRoutes: [
  ],
};
